import React from 'react';

import DifficultySelect from './DifficultySelect';

const DifficultySelectContainer = ({
  readOnly,
  field,
  helpers,
}: {
  readOnly: any;
  field: any;
  helpers: any;
}) => {
  const handleItemClick = (itemValue: any) => {
    if (readOnly) {
      return;
    }

    helpers.setValue(itemValue);
  };

  return (
    <DifficultySelect
      readOnly={readOnly}
      value={field.value}
      onItemClick={handleItemClick}
    />
  );
};

export default React.memo(DifficultySelectContainer) as any;
